<section class="relative w-full h-full">
  <div #actionSheet class="fixed bottom-0 left-0 w-full bg-white rounded-t-2xl">
    <div class="flex justify-between w-full p-4">
      <p class="text-gray-800">{{ title() || '선택' }}</p>
      <p (click)="close()" class="text-gray-400 text-sm">취소</p>
    </div>
    <div class="w-full h-px bg-gray-200"></div>
    @for (option of options(); track option.label) {
    <app-action-sheet-option
      [currentValue]="currentValue()"
      [renderItem]="renderItem()"
      [option]="option"
      (click)="handleClick(option)"
    />
    }
  </div>
</section>
